import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setUserInfoAction } from "../../redux/actions";

import api from "../../utils/api";
import { isEmptyScObj } from "../../utils/siteUtils";
import { getUserInfo } from "../../services/userService";
import { selectUserState } from "../../selectors/application";

import Heading from "../../elements/heading";
import BodyText from "../../elements/body-text";
import Checkbox from "../../elements/checkbox";
import PrimaryButton from "../../elements/primary-button";

function AccountAreaOfInterestSetting(props) {
  if (isEmptyScObj(props)) {
    return null;
  } else {
    return <AccountAreaOfInterestSettingMain {...props} />;
  }
}
function AccountAreaOfInterestSettingMain(props) {
  const {
    fields: { headingType, headingBody, body, button, saveFailedMessage, saveSuccess },
    lang,
    user,
    setUserInfo
  } = props;
  const [serverError, setServerError] = useState(null);
  const [serverSuccess, setServerSuccess] = useState(null);
  const [checkboxes, setCheckboxes] = useState([]);
  const [changeInterestButtonIsDisabled, setChangeInterestsButtonIsDisabled] = useState(true);
  const [selectedInterests, setSelectedInterests] = useState([]);
  const [questionTitleID, setQuestionTitleID] = useState(null);
  const [questionTitleName, setQuestionTitleName] = useState(null);
  useEffect(() => {
    getCheckboxes();
  }, []);

  const getCheckboxes = async () => {
    let language = lang.split("-")[0];

    api.areaInterest.list({ language }).then(res => {
      const questions = res.data?.question?.answerList;
      setQuestionTitleID(res.data?.question?.questionTitleID);
      setQuestionTitleName(res.data?.question?.questionTitleName);
      if (questions) {
        let checks = questions.map(item => ({
          id: item.answerTitleID,
          checked: false,
          label: item.answerTitleName,
          showError: false,
          type: "checkbox"
        }));
        setCheckboxes(checks);
        api.areaInterest.accountAreaOfInterest({ language: language, customerNumber: user.customerNumber }).then(res => {
          const accountAnswers = res.data?.question?.accountAnswer || [];
          let selecteds = checks.filter(x => accountAnswers.includes(x.id));
          setSelectedInterests(selecteds);
        });
      }
    });
  };

  const onInterestsChanged = (checked, option) => {
    let currentSelected = selectedInterests;
    if (checked) {
      if (!currentSelected.includes(option)) {
        currentSelected.push(option);
      }
    } else {
      currentSelected = currentSelected.filter(x => x.id !== option.id);
    }

    setSelectedInterests(currentSelected);
    setChangeInterestsButtonIsDisabled(false);
    setServerError(null);
    setServerSuccess(null);
  };
  const onSubmitInterestsChange = async evt => {
    api.areaInterest
      .update(null, {
        customerNumber: user.customerNumber,
        questionTitleID: questionTitleID,
        questionTitleName: questionTitleName,
        accountAnswerList: selectedInterests.map(item => ({
          answerTitleID: item.id,
          answerTitleName: item.label
        }))
      })
      .then(async res => {
        const userNew = await getUserInfo();
        setUserInfo(userNew);
        setServerSuccess(saveSuccess.value);
      })
      .catch(error => {
        setServerError(saveFailedMessage.value);
      });
    // console.log("interests updated subitted data: ", areaOfInterest,selectedInterests);
    setChangeInterestsButtonIsDisabled(true);
  };

  // console.log(props,checkboxFile,selectedInterests)
  return (
    <div className="section">
      <Heading type={headingType} typographyClass="type-h3" html={headingBody} />
      <BodyText html={body.value} className="form-section-builder-section-body" />
      <div className="areas-of-interest-checkbox-contianer">
        {checkboxes.map((box, index) => {
          return (
            <Checkbox
              {...{
                ...box,
                checked: selectedInterests.includes(box),
                onChange: (checked, option) => onInterestsChanged(checked, option)
              }}
              key={index}
            />
          );
        })}
      </div>
      {serverError !== null && <BodyText className="failed-message" html={serverError} />}
      {serverSuccess !== null && <BodyText className="success-message" html={serverSuccess} />}
      <PrimaryButton
        {...{
          colorScheme: button?.fields?.colorScheme,
          iconName: button?.fields?.iconName,
          buttonText: button?.fields?.buttonText?.value,
          isDisabled: changeInterestButtonIsDisabled,
          callback: evt => onSubmitInterestsChange(evt)
        }}
      />
    </div>
  );
}

const mapStateToProps = state => ({
  user: selectUserState(state)
});
const mapDispatchToProps = dispatch => ({
  setUserInfo: data => dispatch(setUserInfoAction(data))
});
export default connect(mapStateToProps, mapDispatchToProps)(AccountAreaOfInterestSetting);
